import { useCallback, useState } from 'react'
import {
  DEFAULT_SAMPLE,
  loadSampleIfc,
  type SampleIfc,
} from './loadSampleIfc'

// Shared "load a sample IFC with a busy flag + error alert" used by the
// ribbon button, the mobile bar and the empty-state CTA, so the three
// don't each re-implement the same try/catch/finally dance.
//
// `busyId` is the id of the sample currently downloading (null when idle).
// Callers that only need a boolean can read `busyId !== null`.
export function useSampleLoad(): {
  busyId: string | null
  run: (sample?: SampleIfc) => Promise<void>
} {
  const [busyId, setBusyId] = useState<string | null>(null)
  const run = useCallback(async (sample: SampleIfc = DEFAULT_SAMPLE) => {
    setBusyId(sample.id)
    try {
      await loadSampleIfc(sample, { replace: true })
    } catch (err) {
      window.alert(
        err instanceof Error ? err.message : 'Falha a abrir o exemplo.',
      )
    } finally {
      setBusyId(null)
    }
  }, [])
  return { busyId, run }
}
